import { useFlags } from 'launchdarkly-react-client-sdk';

import { usePrintOrderEnabled } from 'componentsV2/print-order';
import { useOutlookReadOnly } from 'pages/outlook/use-outlook-read-only';

export enum DropdownItemsTypes {
  pdf = 'pdf',
  email = 'email',
  moreInfo = 'moreInfo',
  download = 'download',
  viewLink = 'viewLink',
  delete = 'delete',
  ai = 'ai',
  favorites = 'favorites',
  getLink = 'getLink',
  goToCategory = 'goToCategory',
  createPresentation = 'createPresentation',
  addToPresentation = 'addToPresentation',
  print = 'print',
  printOrder = 'printOrder'
}

type ItemType = keyof typeof DropdownItemsTypes;

export type DropdownItemsType = ItemType[];

export const useResourcesDropdownItems = (hiddenItems: string[] = []) => {
  const flags = useFlags();
  const printOrderEnabled = usePrintOrderEnabled();
  // Outlook read mode: nothing can be inserted into the email, so Email (and
  // its "send selected pages" submenu) is not offered in any resources list.
  const readOnly = useOutlookReadOnly();

  const resourcesItems: DropdownItemsType = [
    DropdownItemsTypes.pdf,
    ...(readOnly ? [] : [DropdownItemsTypes.email]),
    DropdownItemsTypes.favorites,
    DropdownItemsTypes.download,
    DropdownItemsTypes.ai,
    ...(flags?.localPrinter ? [DropdownItemsTypes.print] : []),
    ...(printOrderEnabled ? [DropdownItemsTypes.printOrder] : []),
    DropdownItemsTypes.getLink,
    DropdownItemsTypes.moreInfo,
    DropdownItemsTypes.delete,
    ...(flags?.myPresentations
      ? [
          DropdownItemsTypes.createPresentation,
          DropdownItemsTypes.addToPresentation
        ]
      : [])
  ];

  // If hiddenItems are provided, filter based on that
  const filteredItems = hiddenItems
    ? resourcesItems.filter(item => !hiddenItems.includes(item))
    : resourcesItems;

  return { resourcesItems: filteredItems };
};
